module.exports = __webpack_public_path__ + "img/event.9b45fe49.svg";